/*eslint-disable*/
import React from 'react'
import icoLogo from 'assets/img/icon_logo_2.png'

// reactstrap components
import { Row, Container } from 'reactstrap'

function DemoFooter() {
  return (
    <footer className="footer footer-white" style={{ backgroundColor: '#fff' }}>
      <hr style={{ marginTop: 0 }} />
      <Container>
        <div style={{
          paddingTop: '1rem',
          fontSize: '0.8rem',
          textAlign: 'center',
          lineHeight: '1.25rem',
        }}>
          Atenção: essa é uma ferramenta de apoio à consulta, com uma visão organizada das aprovações. A confirmação oficial de resultado e matrícula deve ser feita nos canais oficiais.
        </div>

        <Row>
          <nav className="footer-nav">
            <ul>
              <li>
                <a
                  href="http://evolucional.com.br/"
                  target="_blank"
                  style={{
                    color: '#000',
                    textTransform: 'none',
                    fontWeight: 600,
                    letterSpacing: 2,
                  }}
                >
                  <img src={icoLogo} style={{ paddingRight: 10, height: 35 }} />
                  Evolucional.com.br
                </a>
              </li>
              <li>
                <a
                  href="/termos-de-uso"
                  style={{
                    color: '#000',
                    textTransform: 'none',
                    fontWeight: 400,
                    letterSpacing: 2,
                  }}
                >
                  Termos de Uso
                </a>
              </li>
              <li>
                <a
                   href="/politica-de-privacidade"
                  style={{
                    color: '#000',
                    textTransform: 'none',
                    fontWeight: 400,
                    letterSpacing: 2,
                  }}
                >
                  Política de Privacidade
                </a>
              </li>
            </ul>
          </nav>
          <div className="credits ml-auto" style={{ paddingTop: 30 }}>
            <span
              className="copyright"
              style={{
                color: '#000',
                textTransform: 'none',
                fontWeight: 400,
                letterSpacing: 2,
              }}
            >
              © {new Date().getFullYear()}&nbsp; Evolucional.
            </span>
          </div>
        </Row>
      </Container>
    </footer>
  )
}

export default DemoFooter
